import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';

import { OccupationCard } from '@cpd-app/generated';

@Component({
  selector: 'cpd-occupation-card',
  templateUrl: './occupation-card.component.html',
  styleUrls: ['./occupation-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OccupationCardComponent implements OnInit {
  @Input() public occupation: OccupationCard;

  @Output() public occupationClick = new EventEmitter<OccupationCard>();

  public imageUrl: string;

  public ngOnInit(): void {
    this.generateImageUrl();
  }

  private generateImageUrl(): void {
    this.imageUrl =
      this.occupation.imageName == null
        ? `/assets/images/occupations/hole.jpg`
        : `/assets/images/occupations/${this.occupation.imageName}`;
  }
}
